module.exports = __webpack_public_path__ + "static/media/otherChildEquipment.8a27f518.svg";